import { computed, Directive, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';
import { BrnDialogTitleDirective } from '@spartan-ng/ui-dialog-brain';

import type { ClassValue } from 'clsx';

@Directive({
    selector: '[hlmDialogTitle]',
    standalone: true,
    host: {
        '[class]': '_computedClass()'
    },
    hostDirectives: [ BrnDialogTitleDirective ]
})
export class HlmDialogTitleDirective {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected _computedClass = computed(() => sonaHlm('tw-text-lg tw-font-semibold tw-mb-0', this.userClass()));
}
